export default __webpack_public_path__ + "static/media/aptuno-logo-white.c547a873.svg";